var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("divider", {
        attrs: {
          label: _vm.conversa.assuntoDescricao
            ? _vm.conversa.assuntoDescricao
            : "-"
        }
      }),
      _vm.conversa.mensagemList && _vm.conversa.mensagemList.length > 0
        ? _c(
            "div",
            { staticClass: "mt-1 padding-info" },
            [
              _c(
                "el-row",
                [
                  _c(
                    "el-collapse",
                    _vm._l(_vm.conversa.mensagemList, function(msg) {
                      return _c(
                        "el-collapse-item",
                        { key: msg.id, attrs: { name: msg.id } },
                        [
                          _c("template", { slot: "title" }, [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "lineTable flex title full-width tableList"
                              },
                              [
                                _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      msg.remetente.pessoaFisica
                                        ? msg.remetente.pessoaFisica.nome
                                        : msg.remetente.pessoaJuridica
                                        ? msg.remetente.pessoaJuridica
                                            .razaoSocial
                                        : " - "
                                    )
                                  )
                                ]),
                                _c("span", [_vm._v(" - ")]),
                                _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.formataDataHora(msg.dataEnviada)
                                    ) + "  "
                                  )
                                ])
                              ]
                            )
                          ]),
                          msg.dataLimiteResposta
                            ? _c("el-row", { staticClass: "margin-top" }, [
                                _c("p", [
                                  _c("b", [_vm._v("Data de Vencimento:")]),
                                  _c("span", [
                                    _vm._v(
                                      "  " +
                                        _vm._s(
                                          _vm.formataData(
                                            msg.dataLimiteResposta
                                          )
                                        )
                                    )
                                  ])
                                ])
                              ])
                            : _vm._e(),
                          _c("el-row", { staticClass: "margin-top" }, [
                            _c("p", {
                              domProps: { innerHTML: _vm._s(msg.conteudo) }
                            })
                          ]),
                          _vm._l(msg.anexoList, function(anexo) {
                            return _c("app-download-arquivo", {
                              key: anexo.id,
                              attrs: { arquivo: anexo },
                              on: {
                                download: function($event) {
                                  return _vm.download(anexo)
                                }
                              }
                            })
                          })
                        ],
                        2
                      )
                    }),
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-61f49b58", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-61f49b58","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/central/components/comunicacao/InformacoesConversa.vue
// module id = null
// module chunks = 